'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchExperimentTreatmentsFromEarlyRequest = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var _dispatchAndLogError = require('pricing-pages-unified-ui/utils/dispatchAndLogError');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fetchExperimentTreatmentsFromEarlyRequest = exports.fetchExperimentTreatmentsFromEarlyRequest = function fetchExperimentTreatmentsFromEarlyRequest(requestName) {
  return function (dispatch) {
    dispatch({ type: _ActionTypes.EXPERIMENT_TREATMENTS_REQUESTED });

    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName(requestName);

    if (!earlyRequest) {
      var error = new Error('Error fetching early-requested experiment treatments');
      (0, _dispatchAndLogError.dispatchAndLogError)({
        dispatch: dispatch,
        type: _ActionTypes.EXPERIMENT_TREATMENTS_FAILED,
        error: error
      });
      return _q2.default.Promise.reject(error);
    }

    return new _q2.default.Promise(function (resolve, reject) {
      earlyRequest.whenFinished(function (result) {
        // Make this agnostic to whether we're using the bulk treatment fetch
        // which returns an array, or single treatment fetch which returns just one
        // treatment, not in an array
        if (!Array.isArray(result)) {
          result = [result];
        }
        dispatch({
          type: _ActionTypes.EXPERIMENT_TREATMENTS_RECEIVED,
          payload: { treatments: result }
        });
        resolve(result);
        window.quickFetch.removeEarlyRequest(requestName);
      });

      earlyRequest.onError(function (error) {
        reject(error);
        (0, _dispatchAndLogError.dispatchAndLogError)({
          dispatch: dispatch,
          type: _ActionTypes.EXPERIMENT_TREATMENTS_FAILED,
          error: error
        });
        window.quickFetch.removeEarlyRequest(requestName);
      });
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/EarlyRequestExperimentActions.js
// module id = 876
// module chunks = 4